import type { MESSAGE_TYPE, SERVICE } from './creative.enum'

export class Creative {
    creativeId: string
    label: string
    companyId: string
    // raw text
    message: string
    messageType: MESSAGE_TYPE
    messageCaption?: string
    // waba template
    wabaId?: string
    wabaTemplateId?: string
    wabaComponents?: WabaTemplateComponent[]
    wabaStatus?: string
    wabaLastSync?: Date | string
    wabaName?: string
    wabaLanguage?: string
    wabaCategory?: string
    //
    variables?: string[]
    //
    service: SERVICE
    status: number
    createdAt: string | Date
    updatedAt: string | Date
}

export class WabaTemplateComponent {
    type!: string // "BODY" | "BUTTONS" | "HEADER"
    format?: string // "TEXT"
    text?: string // conteúdo do header ou body
    example?: WabaExample
    add_security_recommendation?: boolean // true
    buttons?: WabaTemplateButton[]
}

export class WabaExample {
    body_text?: string[][]
    // [
    //   [
    //     "{{Clínica Uberlândia}}",
    //     "+551044557788"
    //   ]
    // ]
}

export class WabaTemplateButton {
    type!: string // "URL" | "QUICK_REPLY"
    text!: string // "Recuperar Senha"
    url?: string // "https://pro.zandu.com.br/{{1}}"
    example?: string[]
    // [
    //   "https://pro.zandu.com.br/login?renew=1&token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9..."
    // ]
}
